/**
 * Installment plan popup — open/close only. Prices are calculated in Liquid.
 */
(function () {
  var visibleClass = 'cc-popup--visible';
  var bodyNoScrollClass = 'cc-popup-no-scroll';
  var bodyNoScrollPadRightClass = 'cc-popup-no-scroll-pad-right';

  function openPopup(popupEl) {
    if (!popupEl) return;
    popupEl.setAttribute('aria-hidden', 'false');
    if (popupEl.getAttribute('data-freeze-scroll') === 'true') {
      document.body.classList.add(bodyNoScrollClass);
      var scrollDiv = document.createElement('div');
      scrollDiv.className = 'popup-scrollbar-measure';
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.getBoundingClientRect ? scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth : 0;
      document.body.removeChild(scrollDiv);
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = scrollbarWidth + 'px';
        document.body.classList.add(bodyNoScrollPadRightClass);
      }
    }
    popupEl.classList.add(visibleClass);
    var closeBtn = popupEl.querySelector('.cc-popup-close');
    if (closeBtn) {
      setTimeout(function () { closeBtn.focus(); }, 500);
    }
  }

  function closePopup(popupEl) {
    if (!popupEl) return;
    popupEl.classList.remove(visibleClass);
    popupEl.setAttribute('aria-hidden', 'true');
    var visibleFreeze = document.querySelectorAll('.' + visibleClass + '[data-freeze-scroll="true"]');
    if (visibleFreeze.length === 0) {
      var inner = popupEl.querySelector('.cc-popup-modal');
      var duration = 500;
      if (inner) {
        var cs = getComputedStyle(inner);
        var t = parseFloat(cs.transitionDuration);
        if (t > 0) duration = t * 1000;
      }
      setTimeout(function () {
        document.body.classList.remove(bodyNoScrollClass, bodyNoScrollPadRightClass);
        document.body.style.paddingRight = '';
      }, duration);
    }
  }

  function init() {
    var trigger = document.querySelector('[data-installment-popup-open]');
    var popup = document.getElementById('installment-plan-modal');
    if (!trigger || !popup) return;

    var previouslyFocused = null;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      previouslyFocused = document.activeElement;
      openPopup(popup);
    });

    function onClose() {
      closePopup(popup);
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus();
      }
    }

    popup.querySelectorAll('.cc-popup-close, .cc-popup-background').forEach(function (el) {
      el.addEventListener('click', onClose);
    });

    document.addEventListener('keydown', function (e) {
      if (e.keyCode === 27 && popup.classList.contains(visibleClass)) {
        onClose();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
